import * as React from 'react'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl, useAppRoutes } from '@webapp/hooks'
import messages from './messages'

const CustomizeOrderFormViewChunk = React.lazy(() =>
  import('../../feature-sets/CustomizeOrderFormView').then(
    ({ CustomizeOrderFormView }) => ({
      default: CustomizeOrderFormView,
    })
  )
)

export const CustomizeOrderFormPageTabTypes = {
  DISABLED: 'disabled',
} as const

export type CustomizeOrderFormPageTab =
  (typeof CustomizeOrderFormPageTabTypes)[keyof typeof CustomizeOrderFormPageTabTypes]

export interface CustomizeOrderFormPageParams {
  tab?: CustomizeOrderFormPageTab
}

export const CustomizeOrderFormPage = () => {
  const intl = useProcurifyIntl()
  const { url } = useAppRoutes()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.customizeOrderFormTitle)}
      breadcrumbs={[
        {
          link: url('SettingsPage'),
          name: intl.formatMessage(messages.settingsTitle),
        },
        {
          link: url('CustomizeOrderFormPage', {}),
          name: intl.formatMessage(messages.customizeOrderFormTitle),
        },
      ]}
    >
      <React.Suspense fallback={null}>
        <CustomizeOrderFormViewChunk />
      </React.Suspense>
    </Page>
  )
}
